import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Header from 'components/Header/Header';
import GoBackPanel from 'components/GoBackPanel/GoBackPanel';
import { useSelector } from 'store';

import ProsforaElementSideBar from './components/ProsforaElementSideBar/ProsforaElementSideBar';
import ElementHeading from './components/ElementHeading/ElementHeading';

import './ProsforaElementPage.scss';
import BidHistory from './components/BidHistory/BidHistory';

const ProsforaElementPage = () => {
  const { t } = useTranslation();
  const { elementId } = useParams<{ elementId: string }>();
  const { id: rfpId, traro_element_list } = useSelector((state) => state.rfp.data);
  const element = traro_element_list.find((e) => e.id === Number(elementId))!;

  return (
    <div className="enkrateia-prosfora-element-page">
      <Header />
      <div className="content">
        <ProsforaElementSideBar element={element} />
        <main>
          <GoBackPanel variant="plain" target={`/rfp/${rfpId}`} label={t('pages.traroElement.goBack')} />
          <ElementHeading element={element} />
          <BidHistory element={element} />
        </main>
      </div>
    </div>
  );
};

export default ProsforaElementPage;
